/* ==========================================================================
   nb-product-leglue.js — Le-Glue-produktsiden.
   Port af logikken i design_handoff_leglue/design/LeGlue.dc.html
   (BEHAVIOR.md): fælles add-to-cart for hoved-CTA + sticky bar og
   FAQ-accordion med én åben ad gangen.

   Ingen dansk tekst i denne fil — alle strenge kommer fra data-attributter.
   Alt er idempotent (Section Rendering API kan re-rendere DOM).

   ÆNDRET 27-08-2026 — ANTALSVÆLGER
   Filen lagde altid præcis ét stk i kurven (quantity: 1 var hardkodet).
   Nu læses antallet fra [data-nb-leglue-qty] inde i købsblokken, med 1 som
   fallback hvis feltet ikke findes — så siden virker uændret, hvis vælgeren
   slås fra i theme editor.

   Bemærk at BEGGE CTA'er (hovedknap + sticky bar) deler samme handler og
   samme root. Sticky-baren har ikke sin egen vælger, så den lægger det antal
   i kurven, kunden har valgt i købsboksen ovenfor. Det er med vilje —
   alternativet ville være to felter, der kan komme i modstrid.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- fælles helpers (samme mønster som nb-product-mini.js) ---------- */

  function withSections(payload) {
    var cartApi = window.NBCart;
    if (cartApi && typeof cartApi.sectionsPayload === 'function') {
      var extra = cartApi.sectionsPayload();
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
      }
    }
    return payload;
  }

  function addToCart(addUrl, items) {
    return fetch((addUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ items: items }))
    }).then(function (response) {
      return response
        .json()
        .catch(function () { return {}; })
        .then(function (data) {
          if (!response.ok) {
            var error = new Error('nb-leglue');
            error.data = data;
            throw error;
          }
          return data;
        });
    });
  }

  function afterAdd(data) {
    var cartApi = window.NBCart;
    var instant = !!(data && data.sections && cartApi && typeof cartApi.apply === 'function' && cartApi.apply(data.sections));
    if (!instant && cartApi && typeof cartApi.refresh === 'function') cartApi.refresh();
    if (cartApi && typeof cartApi.get === 'function') {
      cartApi.get().then(function (cart) {
        window.dispatchEvent(new CustomEvent('nb-cart-updated', { detail: { cart: cart || null } }));
      });
    }
  }

  function errorText(error, fallback) {
    var data = error && error.data;
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message) return data.message;
    return fallback || '';
  }

  /* ---------- antal ---------- */

  // Falder tilbage paa 1, hvis feltet ikke findes — saa virker knappen ogsaa,
  // naar vaelgeren er slaaet fra i theme editor.
  function qtyOf(root) {
    var input = root && root.querySelector('[data-nb-leglue-qty]');
    var n = input ? parseInt(input.value, 10) : 1;
    if (!n || n < 1) n = 1;
    if (n > 99) n = 99;
    return n;
  }

  function initQty(root) {
    var input = root.querySelector('[data-nb-leglue-qty]');
    if (!input) return;

    function set(n) {
      if (!n || n < 1) n = 1;
      if (n > 99) n = 99;
      input.value = n;
      var minus = root.querySelector('[data-nb-leglue-qty-step="-1"]');
      if (minus) minus.disabled = n <= 1;
    }

    // Delegation paa root frem for listeners paa knapperne: sektionen kan
    // gen-renderes, og da udskiftes knapperne med nye noder.
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-nb-leglue-qty-step]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      set(qtyOf(root) + (parseInt(btn.getAttribute('data-nb-leglue-qty-step'), 10) || 0));
    });

    input.addEventListener('change', function () { set(qtyOf(root)); });
    input.addEventListener('blur', function () { set(qtyOf(root)); });

    set(qtyOf(root));
  }

  /* ---------- fælles add-to-cart: hoved-CTA + sticky bar ---------- */

  function initBuy(root) {
    if (!root || root.__nbLeglueBound) return;
    root.__nbLeglueBound = true;

    var variantId = root.getAttribute('data-nb-variant-id');
    var available = root.getAttribute('data-nb-available') === 'true';
    var addUrl = root.getAttribute('data-nb-add-url');

    initQty(root);

    function labels(name, fallback) {
      var value = root.getAttribute('data-nb-i18n-' + name);
      return value === null || value === '' ? fallback : value;
    }

    // Begge CTA'er (hovedknap + sticky) deler denne handler (BEHAVIOR.md §1).
    function bindButton(button) {
      if (!button || button.__nbLeglueBound) return;
      button.__nbLeglueBound = true;
      if (!available) { button.disabled = true; return; }

      button.addEventListener('click', function () {
        if (button.disabled || button.getAttribute('data-nb-state') === 'adding') return;

        var errorEl = document.querySelector('[data-nb-leglue-error]');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.hidden = true;
        }

        var label = button.querySelector('[data-nb-leglue-label]');
        var idle = label ? label.textContent : '';
        button.setAttribute('data-nb-state', 'adding');
        if (label) label.textContent = labels('adding', idle);

        // Draweren aabnes med det samme; indholdet foelger i svaret (sections).
        window.dispatchEvent(new CustomEvent('nb-cart-open'));

        addToCart(addUrl, [{ id: variantId, quantity: qtyOf(root) }])
          .then(function (data) {
            afterAdd(data);
            if (label) label.textContent = labels('added', idle);
            window.setTimeout(function () {
              button.removeAttribute('data-nb-state');
              if (label) label.textContent = idle;
            }, 1200);
          })
          .catch(function (error) {
            button.removeAttribute('data-nb-state');
            if (label) label.textContent = idle;
            if (errorEl) {
              errorEl.textContent = errorText(error, labels('error', ''));
              errorEl.hidden = false;
            }
          });
      });
    }

    document.querySelectorAll('[data-nb-leglue-add]').forEach(bindButton);
  }

  /* ---------- FAQ-accordion: én åben ad gangen (BEHAVIOR.md §2) ---------- */

  function initFaq(root) {
    if (!root || root.__nbLeglueBound) return;
    root.__nbLeglueBound = true;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-nb-faq-item]'));

    function setOpen(item, open) {
      var button = item.querySelector('[data-nb-faq-btn]');
      var answer = item.querySelector('[data-nb-faq-a]');
      item.classList.toggle('is-open', open);
      if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (answer) answer.hidden = !open;
    }

    items.forEach(function (item) {
      var button = item.querySelector('[data-nb-faq-btn]');
      if (!button) return;
      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) { setOpen(other, false); });
        if (!isOpen) setOpen(item, true);
      });
    });
  }

  /* ---------- init ---------- */

  function init() {
    document.querySelectorAll('[data-nb-leglue-buy]').forEach(initBuy);
    document.querySelectorAll('[data-nb-leglue-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ------------------------------------------------------------------------
   <nb-mini-countdown> — samme ORDRETTE port af designets nb-countdown som i
   nb-product-mini.js (design/nb-widgets.js er identisk i begge handoffs).
   Guardet, så definitionen kun registreres én gang, uanset hvilken side
   der loader først.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';
  if (customElements.get('nb-mini-countdown')) return;

  class NbMiniCountdown extends HTMLElement {
    connectedCallback() {
      this.cutoff = parseInt(this.getAttribute('cutoff') || '14', 10);
      this.theme = this.getAttribute('theme') || 'light';
      this.render();
      this._t = setInterval(() => this.render(), 1000);
    }
    disconnectedCallback() { clearInterval(this._t); }
    pad(n) { return String(n).padStart(2, '0'); }
    addBusinessDays(date, n) {
      const d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) n--; }
      return d;
    }
    fmtDate(d) {
      const days = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
      const months = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
      return days[d.getDay()] + ' d. ' + d.getDate() + '. ' + months[d.getMonth()];
    }
    render() {
      const now = new Date();
      const day = now.getDay(); // 0=søn,6=lør
      const cut = new Date(now); cut.setHours(this.cutoff, 0, 0, 0);
      const weekend = day === 0 || day === 6;
      const beforeCut = !weekend && now < cut;
      const ink = this.theme === 'dark' ? '#F4ECDF' : '#3A2E22';
      const sub = this.theme === 'dark' ? '#C9BBA9' : '#8A7A6D';
      let ship = new Date(now); ship.setHours(0, 0, 0, 0);
      if (!beforeCut) ship = this.addBusinessDays(ship, 1);
      const deliver = this.fmtDate(this.addBusinessDays(ship, 2));
      let head;
      if (beforeCut) {
        const d = cut - now;
        const h = Math.floor(d / 3600000);
        const m = Math.floor((d % 3600000) / 60000);
        const s = Math.floor((d % 60000) / 1000);
        head = 'Bestil inden <b style="font-variant-numeric:tabular-nums;color:#1A5FE0;">' + this.pad(h) + ':' + this.pad(m) + ':' + this.pad(s) + '</b> — så sender vi <b>i dag</b>';
      } else {
        head = 'Bestil nu — vi sender <b>' + (weekend ? 'på mandag' : 'næste hverdag') + '</b>';
      }
      this.innerHTML =
        '<span style="display:flex;align-items:flex-start;gap:11px;font-family:Nunito,sans-serif;">' +
          '<span style="font-size:20px;flex:none;line-height:1.25;">' + (beforeCut ? '🚚' : '📦') + '</span>' +
          '<span style="line-height:1.35;">' +
            '<span style="display:block;font-size:13.5px;font-weight:700;color:' + ink + ';">' + head + '</span>' +
            '<span style="display:block;font-size:12.5px;font-weight:700;color:' + sub + ';margin-top:2px;">📅 Modtag <b style="color:' + ink + ';">senest ' + deliver + '</b></span>' +
          '</span>' +
        '</span>';
    }
  }
  customElements.define('nb-mini-countdown', NbMiniCountdown);
})();